export default "__VITE_ASSET__7jLdrokm__"